<template>
  <div>
    <!-- 수퍼어드민 페이지 -->
    <div class="columns is-multiline">
      <div class="column is-6">

        <!-- 저장하기 -->
        <div class="btn-group-justify-end" v-if="!$route.query.id">
          <button class="button is-primary" @click="inquiryCreate">저장하기</button>
        </div>
        <div class="box">
          <admin-box-item title="문의 내용" subtitle="서비스 등록을 통한 서비스를 하고 있는 고객에게 문의 답변을 남깁니다.">
            <div class="columns is-multiline">
              <div class="column is-full" v-if="$route.query.id===undefined">
                <admin-form-item label="서비스명*">
                  <span class="select">
                    <select v-model="value.service_id" @change="e=> value.service_id=e.target.value">
                      <option value="" disabled selected>서비스명</option>
                      <option :value="service.value"
                              v-for="(service,idx) in serviceList"
                              :key="'service-'+idx">{{ service.label }}</option>
                    </select>
                  </span>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id">
                <admin-form-item label="서비스명">
                  {{ value.service_name }}
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id===undefined">
                <admin-form-item label="문의유형*">
                  <span class="select">
                    <select v-model="value.type_id" @change="e=> value.type=e.target.value">
                      <option value="" disabled selected>문의유형</option>
                      <option :value="cat.value" v-for="cat in cats">{{ cat.label }}</option>
                    </select>
                  </span>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="문의유형" v-if="$route.query.id">
                  {{ value.cat }}
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id">
                <admin-form-item label="작성일">
                  {{ value.created_time }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :label="`${value.type === 6 ? '페이지명' : '제목'}*`">

                  <input v-if="$route.query.id===undefined"
                         class="input"
                         :value="value.title"
                         @input="e=> value.title = e.target.value"
                         type="text"
                         maxlength="30">
                  <div v-else>{{ value.title }}</div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :label="`${value.type === 6 ? '페이지 설명' : '내용'}*`">
                  <textarea class="textarea" v-if="$route.query.id===undefined"
                            v-model="value.content"></textarea>
                  <div v-else style="white-space: pre-line">{{ value.content }}</div>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id===undefined">
                <admin-form-item label="첨부파일(이미지, pdf, ppt, doc, xls, hwp)" :isHeaderBlock="true" desc="최대 10개까지 등록 가능합니다.">
                  <div class="flex">
                    <!--<old-input-file :maxLength="10" :files.sync="value.imgs" @remove="idx=>removeIndex(value.imgs,idx)"></old-input-file>-->
                    <input-file :value.sync="value.imgs_ext" @setValue="val=>value.imgs=val"></input-file>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id && value.imgs.length>0">
                <admin-form-item label="첨부 파일">
                  <a v-for="(file,idx) in value.imgs" :key="'file-'+idx" style="text-decoration: underline" :href="file" target="_blank" download>
                    <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>
                    {{ `파일${idx+1}.${file.split('.')[file.split('.').length-1]}` }}
                  </a>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query && value.schedule">
                <admin-form-item label="진행 상태">
                  <div class="flex-align" style="gap:12px">
                    <div>{{ statusOption.find(i => i.value === value.schedule.status).label }}</div>
                    <button class="button" v-if="!editableStatus" @click="clickStatusEdit">상태 변경</button>
                  </div>
                  <div class="flex-align" v-if="editableStatus" style="margin-top:8px;gap:8px">
                    <div class="select">
                      <select v-model="status">
                        <option v-for="(opt,idx) in statusOption" :key="`status-opt-${idx}`" :value="opt.value">{{ opt.label }}</option>
                      </select>
                    </div>
                    <button class="button is-primary" @click="saveScheduleStatus">변경</button>
                    <button class="button" @click="editableStatus=false">취소</button>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-6">
        <div class="box" v-if="$route.query.id">
          <admin-box-item title="1:1 문의 답변 등록">
            <div class="columns is-multiline">
              <div class="column is-full">
                <!-- 댓글 -->
                <admin-form-item label="댓글 목록">
                  <div class="comment-list-box" v-if="comment_list.length>0">
                    <div v-for="(item, idx) in comment_list"
                         :key="'comments'+idx"
                         :class="{'comment-align-right': item.author_type==='user'}"
                         style="margin-bottom:12px">
                      <div>
                        <div class="flex-align" style="font-size:11px">
                          <div :class="{'primary-display-name':item.author_type==='admin'}">{{ item.display_name }}</div>
                          <div v-if="item.is_internal_comment" style="color:#2196f3;margin-left:4px">내부 메모</div>
                          <div style="margin-left: 12px">{{ item.created_time }}</div>
                          <div @click="deleteComment(item)"
                               class="unselect"
                               style="padding-left: 10px;">삭제</div>
                        </div>
                        <div :class="{'flex-end':item.author_type==='user'}">
                          <div class="comment-div" :class="{'flex-end':item.author_type==='user'}">
                            <div>{{ item.content }}</div>
                            <div v-if="item.author_type==='admin' && item.imgs && item.imgs.length > 0" style="margin-top: 8px">
                              <a v-for="(file,idx) in item.imgs" :key="'file-'+idx"
                                style="white-space: nowrap; text-decoration: underline" :style="fileStyle(item.imgs, idx)"
                                :href="file" target="_blank" download>
                                <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>
                                {{ `파일${idx+1}.${file.split('.')[file.split('.').length-1]}` }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>댓글이 없습니다.</div>
                </admin-form-item>

                <admin-form-item label="댓글 작성">
                  <div style="margin-bottom: 10px;">
                    <span class="select">
                      <select v-model="comments.is_internal_comment"
                              @change="selectInternalComment">
                        <option :value="false" selected>기본</option>
                        <option :value="true">내부 메모</option>
                      </select>
                    </span>
                  </div>
                  <div class="flex">
                    <div style="margin-right:12px;width:90%">
                      <textarea class="textarea" v-model="comments.content"></textarea>
                    </div>
                    <div>
                      <button class="button is-primary"
                              style="height: 100% !important"
                              @click="regComment">등록
                      </button>
                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="첨부 파일(이미지, pdf, ppt, doc, xls, hwp)">
                  <div class="flex">


                    <!--<old-input-file :files.sync="value.answer_imgs"-->
                    <!--v-if="showFile"-->
                    <!--@remove="idx=>removeIndex(value.answer_imgs,idx)"></old-input-file>-->
                    <input-file :value.sync="comments.imgs_ext" @setValue="val=>comments.imgs=val"></input-file>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import InputImg from "../../../module/common/InputImg";
  import OldInputFile from "../../../module/common/OldInputFile";
  import InputFile from "../../../module/common/InputFile";
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  export default {
    components: {
      AdminFormItem,
      InputFile,
      OldInputFile,
      InputImg, draggable},
    data() {
      return {
        status: 1,
        editableStatus: false,
        statusOption: [
          {label: '신청', value: 1},
          {label: '이용중', value: 2},
          {label: '이용중단', value: 3},
          {label: '안내완료', value: 4},
          {label: '결제완료', value: 5},
          {label: '작업중', value: 6},
        ],
        value: {
          service_id: '',
          title: '',
          content: '',
          imgs: [],
          type_id: '',
          answer_imgs: []
        },
        cats: [],
        serviceList: [],
        showFile: false,
        // 댓글 목록
        comment_list: [],
        comments: {
          id: "", // 상품문의상세 게시글 id
          content: "",
          imgs: [],
          is_internal_comment: false  // 내부 메모 여부
        }
      }
    },
    created(){

      this.getData();
      this.getCommentList();
    },
    methods: {
      clickStatusEdit() {
        this.status = this.value.schedule.status;
        this.editableStatus = true;
      },
      saveScheduleStatus() {
        this.$axios.patch(`admin/launchpack/service/${this.value.service}/schedule/${this.value.schedule.id}`,
          {status: this.status }).then(res=>{
            if(res.status === 200) {
              this.value.schedule.status = this.status;
              this.editableStatus = false;
            }
        });
      },
      fileStyle(imgs, idx) {
        let deco = {
          marginBottom: '8px'
        }
        if (idx === imgs.length - 1) {
          deco.marginBottom = '0px';
        }
        return deco;
      },
      selectInternalComment(e) {
        this.comments.is_internal_comment = e.target.value === 'true';
      },
      updateComment (item) {
        this.comments.id = item.id;
        this.comments.content = item.content;
      },
      deleteComment (item) {
        this.$axios.delete(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment/${item.id}`)
          .then(res=>{
            if(res.status===200){
              this.toast('삭제되었습니다.');
              this.getCommentList();
            }
          })
      },
      getCommentList() {
        this.$axios.get(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment`)
          .then(res=>{
            this.comment_list = res.data;
          })
      },
      regComment () {
        console.log(this.comments, 'test')
        if(!this.comments.content) {
          this.toast('댓글을 작성해주세요.');
          return;
        }
        if(this.comments.id) {
          this.$axios.patch(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment/${this.comments.id}`, this.comments).then(res=>{
            if(res.status===200) {
              this.toast('수정이 완료되었습니다.');
              this.getCommentList();
            }
          })
        }
        else {
          this.$axios.post(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment`, this.comments).then(res=>{
            if(res.status===200) {
              this.toast('저장이 완료되었습니다.');
              this.comments = {
                id: "",
                imgs: [],
                imgs_ext: [],
                content: "",
                is_internal_comment: false
              }
              this.getCommentList();
            }
          })
        }
      },
      getServiceSimpleList() {
        this.$axios.get('admin/launchpack/service/simple').then(res=> {
          this.serviceList = res.data;
        })
      },
      getCategory() {
        this.$axios.get('public/launchpack/inquiry/customer/category').then(res=>{
          this.cats = res.data;
        })
      },
      // 문의 등록
      inquiryCreate() {
        let err = '';
        if(!this.value.service_id) err='서비스를 선택해주세요.';
        else if(!this.value.title) err='제목을 입력하세요.';
        else if(!this.value.content) err='내용을 입력하세요.';
        else if(!this.value.type_id) err='문의 유형을 선택 하세요.';

        if(err) {
          this.toast(err);
          return;
        }
        this.$axios.post('public/launchpack/inquiry/customer', this.value).then(res=>{
          this.toast('문의가 등록되었습니다.')
          this.$router.replace(this.getPath('launchpack/inquiry/customer'));
        })
      },
// 답변 등록
      clickCommentsReg() {
        let param = {
          answer_content: this.value.answer_content,
          answer_imgs: this.value.answer_imgs
        }
        this.$axios.patch('admin/launchpack/inquiry/customer/'+this.$route.query.id, param
        ).then(res=>{
          if(res.status===200){
            this.toast('완료되었습니다.');
            this.$router.back();
          }
        })

      },
      getData(){
        this.getServiceSimpleList();
        this.getCategory();
        if(this.$route.query.id){
          this.$axios.get('admin/launchpack/inquiry/customer/'+this.$route.query.id)
            .then(res=>{
              this.value = res.data;
              this.showFile = true;
            })
        }
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .comment-sub-title
    background #ddd
    color #333
    padding 8px 16px
    font-size 0.95rem
    border-radius 3px
    display flex
    justify-content space-between

  .ask-content
    width 260px
    padding 6px 10px
    font-size .85rem
    color #555
    border-radius 3px
    display inline-block
    border 1px solid #ddd

  .lp-img-bg
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0,0,0,0.5)
    z-index 100

  .lp-img-full
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
    max-height 80vh

  .primary-display-name
    color $primary

  .comment-list-box
    border 1px solid #eee
    border-radius 4px
    padding 4px 8px
    margin-bottom 16px
    height 300px
    overflow-y scroll

  .comment-align-right
    display flex
    flex-wrap wrap
    flex-direction row-reverse

  .comment-div
    font-size 13px
    background-color #eee
    border-radius 4px
    padding 4px 8px
    margin 4px 0
    display table
    max-width 100%
    white-space pre-line
</style>
